const STORAGE_KEY_GDPR = "gdpr"

let gdprContainer = document.getElementById("gdpr-container")

let agreed = document.getElementById("gdpr-agreed")
agreed.addEventListener('click', () => {
  localStorage.setItem(STORAGE_KEY_GDPR, true)
  gdprContainer.style.display = "none"
})

let disagreed = document.getElementById("gdpr-disagreed")
disagreed.addEventListener('click', () => {
  localStorage.setItem(STORAGE_KEY_GDPR, false)
  gdprContainer.style.display = "none"
})

let gdpr = localStorage.getItem(STORAGE_KEY_GDPR)
if (gdpr == "true") {
  gdprContainer.style.display = "none"
}

window.showBoxError = (msg) => {
  let error = document.getElementById("box-error")
  let info = document.getElementById("box-info")
  info.style.display = 'none'
  error.innerHTML = msg
  error.style.display = "block"
}

const valid = () => {
  let emailInput = document.getElementById("email")
  let passwordInput = document.getElementById("password")
  let email = emailInput.value
  let password = passwordInput.value
  if (email == undefined || email == "") {
    return false
  }
  if (password == undefined || password == "") {
    return false
  }
  return true
}

const signinButtonEnabled = (enabled) => {
  let signinButton = document.getElementById("check-button")
  if (enabled) {
    signinButton.classList.remove("disabled")
    signinButton.disabled = false
    signinButton.classList.add("primary")
  } else {
    signinButton.classList.add("disabled")
    signinButton.disabled = true
    signinButton.classList.remove("primary")
  }
}

let signinButton = document.getElementById("check-button")
signinButton.addEventListener("click", (e) => {
  showLoading()
  let emailInput = document.getElementById("email")
  let passwordInput = document.getElementById("password")
  let email = emailInput.value
  let password = passwordInput.value
  document.getElementById("signin-form").submit()
})
let emailInput = document.getElementById("email")
emailInput.addEventListener("input", (e) => {
  signinButtonEnabled(valid())
})
let passwordInput = document.getElementById("password")
passwordInput.addEventListener("input", (e) => {
  signinButtonEnabled(valid())
})


